import { put, call } from 'redux-saga/effects';
import { payLevelsList, payLevelsAdd, payLevelsEdit, payLevelsUpdate, payLevelsDelete } from '../../../services/settings/affiliates/payLevelService';

import * as types from '../../../actions';

export function* payLevelsListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(payLevelsList, payload);
      yield put({ type: types.PAY_LEVELS_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.PAY_LEVELS_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
  }

export function* payLevelsAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(payLevelsAdd, payload);
      yield put({ type: types.PAY_LEVELS_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.PAY_LEVELS_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* payLevelsEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(payLevelsEdit, payload);
    yield put({ type: types.PAY_LEVELS_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.PAY_LEVELS_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* payLevelsUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(payLevelsUpdate, payload);
    yield put({ type: types.PAY_LEVELS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.PAY_LEVELS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* payLevelsDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(payLevelsDelete, payload);
    yield put({ type: types.PAY_LEVELS_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.PAY_LEVELS_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}